import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthProvider } from 'src/app/providers';
import { ToasterService, CommonService } from 'src/app/services';

declare var grecaptcha: any;

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  resetForm: UntypedFormGroup;
  linkSent: boolean = false;
  emailSentOn: string = '';
  error: string = '';
  captchaVisible: boolean = false;
  isPswdChanged: boolean = true;
  newMessage: string = '';

  constructor(
    private fb: UntypedFormBuilder,
    private authProvider: AuthProvider,
    private toastr: ToasterService,
    private router: Router,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      USER_EMAIL: [null, [Validators.required, Validators.pattern('^[_aA-zZ0-9\-\_\+]+(\.[_aA-zZ0-9\-\_\+]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$')]]
    })
  }

  /**
   * @description When clicked, process forgot password.
   */
  resetPassword(): void {
    if (this.resetForm.valid) {
      this.error = '';
      this.authProvider.resetUserByEmail(this.resetForm.value.USER_EMAIL).subscribe(response => {
        if (response.success) {
          this.linkSent = true;
          this.emailSentOn = this.resetForm.value.USER_EMAIL;
          this.resetForm.reset();

          // added for new email stuff
          if (response?.result && response?.result?.MESSAGE) {
           this.isPswdChanged = false;
           this.newMessage = response.result.MESSAGE;
          }

          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 6000);
        } else {
          this.captchaVisible = response.captcha;
          this.error = response.error.txt;
          if (this.captchaVisible) {
            grecaptcha.reset();
          }
        }
      }, err => {
        console.error(err);
      });
    } else {
      this.resetForm.markAllAsTouched();
    }
  }

  /**
   * @description check validation of form
   */
  checkControlValid(controlName: string) {
    const controlDetails = this.resetForm.get(controlName);
    if (!controlDetails) {
      return false;
    }
    return (controlDetails.touched || controlDetails.dirty) && controlDetails.invalid;
  }

  /**
   * @description email change event
   */
  emailChange() {
    if (this.error) {
      this.error = '';
    }
  }

  /**
   * @description goto login page
   */
  backToLogin() {
    this.router.navigate(['/login']);
  }

  public resolved(captchaResponse: string): void {
    // blank
  }

}
